import type { FiatPrice } from "@hopper-b2b/types";

export enum RewardsPaymentEventTypes {
  SET_REWARDS_SELECTED = "SET_REWARDS_SELECTED",
  SET_REWARDS_UNSELECTED = "SET_REWARDS_UNSELECTED",
  SET_REWARDS_AMOUNT_TO_PAY = "SET_REWARDS_AMOUNT_TO_PAY",
  SET_REWARDS_AMOUNT_TO_PAY_IN_CASH = "SET_REWARDS_AMOUNT_TO_PAY_IN_CASH",
  SET_REWARDS_BALANCE = "SET_REWARDS_BALANCE",
  CLEAR_REWARDS_PAYMENT_ERROR = "CLEAR_REWARDS_PAYMENT_ERROR",
  PREVIOUS = "PREVIOUS",
  NEXT = "NEXT",
}

export interface SetRewardsSelected {
  type: RewardsPaymentEventTypes.SET_REWARDS_SELECTED;
}

export const setRewardsSelected = (): SetRewardsSelected => ({
  type: RewardsPaymentEventTypes.SET_REWARDS_SELECTED,
});

export interface SetRewardsUnselected {
  type: RewardsPaymentEventTypes.SET_REWARDS_UNSELECTED;
}

export const setRewardsUnselected = (): SetRewardsUnselected => ({
  type: RewardsPaymentEventTypes.SET_REWARDS_UNSELECTED,
});

export interface SetRewardsAmountToPayEvent {
  type: RewardsPaymentEventTypes.SET_REWARDS_AMOUNT_TO_PAY;
  rewardsAmountToPay: number;
}

export const setRewardsAmountToPay = (
  rewardsAmountToPay: number
): SetRewardsAmountToPayEvent => ({
  type: RewardsPaymentEventTypes.SET_REWARDS_AMOUNT_TO_PAY,
  rewardsAmountToPay,
});

export interface SetRewardsToPayInCashEvent {
  type: RewardsPaymentEventTypes.SET_REWARDS_AMOUNT_TO_PAY_IN_CASH;
  rewardsAmountToPayInCash: FiatPrice;
}

export const setRewardsAmountToPayInCash = (
  rewardsAmountToPayInCash: FiatPrice
): SetRewardsToPayInCashEvent => ({
  type: RewardsPaymentEventTypes.SET_REWARDS_AMOUNT_TO_PAY_IN_CASH,
  rewardsAmountToPayInCash,
});

export interface ClearRewardsPaymentErrorEvent {
  type: RewardsPaymentEventTypes.CLEAR_REWARDS_PAYMENT_ERROR;
}

export interface SetRewardsBalanceEvent {
  type: RewardsPaymentEventTypes.SET_REWARDS_BALANCE;
  rewardsBalance: number;
  rewardsBalanceInCash: FiatPrice;
}

export const setRewardsBalance = (
  rewardsBalance: number,
  rewardsBalanceInCash: FiatPrice
): SetRewardsBalanceEvent => ({
  type: RewardsPaymentEventTypes.SET_REWARDS_BALANCE,
  rewardsBalance,
  rewardsBalanceInCash,
});

export type RewardsPaymentEvents =
  | SetRewardsSelected
  | SetRewardsUnselected
  | SetRewardsAmountToPayEvent
  | ClearRewardsPaymentErrorEvent
  | SetRewardsToPayInCashEvent
  | SetRewardsBalanceEvent;
